<template>
  <div class="box-wrap">
    <div class="step-left-wrap">
      <div class="step-title">보관 박스 개수</div>
      <div class="guide">보관 박스 사이즈 TIP

        <Popover dir="bottom" refKey="popover-box">
          <template #trigger>
            <button class="btn btn-icon">
              <i class="xi-help"></i>
            </button>
          </template>
          <div class="popover-content">
            <BoxStandard size="small" box-type="storage_main"></BoxStandard>
          </div>
        </Popover>
      </div>
    </div>

    <div class="step-right-wrap box-cnt-wrap flex-center">
      <button class="btn-circle-border-icon" tabindex="-1" type="button" @click="decreaseBoxCnt" :disabled="!!disabled">
        <i class="xi-minus"></i>
      </button>
      <input type="number" class="input" tabindex="-1" :value="modelValue"
             @blur="blurBoxCnt"
             :disabled="!!disabled"
             @input="$emit('update:modelValue', $event.target.value)">
      <span>개</span>
      <button class="btn-circle-border-icon" tabindex="-1" type="button" @click="increaseBoxCnt" :disabled="!!disabled">
        <i class="xi-plus"></i>
      </button>
    </div>

    <TheBoxCntSlider class="tablet-show mt-5" :value="modelValue" @input="updateValue"></TheBoxCntSlider>
  </div>
</template>

<script>
import Popover from "@/components/Popover";
import BoxStandard from "@/components/BoxStandard";
import TheBoxCntSlider from "@/components/TheBoxCntSlider";

export default {
  name: "StorageBoxSelectV2",
  components: {
    Popover,
    BoxStandard,
    TheBoxCntSlider
  },
  props: ['modelValue', 'disabled'],
  emits: ['update:modelValue'],
  methods: {
    decreaseBoxCnt() {
      if (this.modelValue > 1) {
        this.$emit('update:modelValue', this.modelValue - 1);
      }
    },
    increaseBoxCnt() {
      if (this.modelValue < 100) {
        this.$emit('update:modelValue', this.modelValue + 1);
      }
    },
    // 박스 개수 변경 이벤트 핸들러
    blurBoxCnt() {
      if (this.modelValue < 1) {
        this.$emit('update:modelValue', 1);
      } else if (this.modelValue > 100) {
        this.$emit('update:modelValue', 100);
      }
    },
    updateValue(newValue) {
      this.$emit('update:modelValue', newValue);
    }
  }
}
</script>

<style lang="scss" scoped>
  .box-wrap {
    background-color: #fff;
    border-radius: 10px;
    padding: 30px 45px;

    .step-left-wrap {
      display: inline-block;
    }

    .step-title {
      font-size: 23px;
      line-height: 34px;
      font-weight: 900;
      letter-spacing: -0.23px;
    }

    .guide {
      color: #7F7F7F;
      font-size: 13px;
      line-height: 19px;
      padding-top: 5px;
      font-weight: bold;

      button {
        vertical-align: top;
        background: none;
      }

      i {
        color: $main-color;
        font-size: 17px;
        vertical-align: top;
        padding-top: 1px;
      }
    }

    .box-cnt-wrap {
      @include respond(not-xs-mobile) {
        float: right;
      }
      @include respond(xs-mobile) {
        margin-top: 20px;
      }

      input {
        width: 120px;
        height: 50px;
        border-radius: 5px;
        text-align: center;
        font-weight: bold;

        &:disabled {

        }
      }

      span {
        font-size: 17px;
        padding-left: 7px;
      }

      .btn-circle-border-icon {
        width: 25px;
        height: 25px;
        font-size: 9px;

        &:nth-of-type(1) {
          margin-right: 10px;
        }
        &:nth-of-type(2) {
          margin-left: 10px;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }



    @include respond(tablet) {
      //padding: 15px 25px;

      .step-title {
        font-size: 18px;
        line-height: 26px;
        letter-spacing: -0.18px;
      }
      .guide {
        font-size: 10px;
        line-height: 15px;
        i {
          font-size: 14px;
        }
      }

      .box-cnt-wrap {
        input {
          width: 100px;
          height: 45px;
        }

        span {
          font-size: 11px;
          padding-left: 5px;
        }

        .btn-circle-border-icon {
          &:nth-of-type(1) {
            margin-right: 5px;
          }
          &:nth-of-type(2) {
            margin-left: 5px;
          }
        }
      }
    }


    @include respond(lg-height-tablet) {
      padding: 30px 15px 15px;
    }
  }
</style>
<style lang="scss">
.estimate-form .box-wrap {
  .popover {
    padding: 0;
    left: -70px;

    .box-size-guide-tip-wrap {
      //padding: 15px 10px;
      background-color: #fff;

      .black-badge {
        font-size: 12px;
        line-height: 20px;
      }

      p {
        font-size: 12px;
        line-height: 20px;
      }

      .img-guide {
        padding-top: 7px;
        font-size: 10px;
      }

      .block-box {
        width: 110px;
      }
    }
  }
}
</style>
